import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const CancellationDisclaimerContainer = styled.div(({ theme }) => ({
    margin: `${theme.spacing.empty} ${theme.spacing.medium}`,
    marginTop: theme.spacing.small,
    padding: `${theme.spacing.small} ${theme.spacing.xSmall}`,
    paddingBottom: "5px",
}));

export const StyledText = styled(Text)(() => ({
    marginBottom: "1px",
}));
